export default __webpack_public_path__ + "static/media/role.02926174.mp3";